// ⚠️ INTERRUPTOR DE PRUEBA — NO ES COMPORTAMIENTO DEFINITIVO ⚠️
//
// Pisa las miniaturas de EJEMPLO de las vistas de maniquí invisible en el picker de vistas
// ("Elegí las vistas", modo Catálogo). Es sólo para mirar cómo se ven: la vista sigue
// siendo la misma —mismo id, misma compatibilidad, mismo payload— y lo que se genera no
// cambia. Sólo cambia la foto de la tarjeta.
//
// ── CÓMO VOLVER ATRÁS ─────────────────────────────────────────────────────────────────
// Poner `VISTAS_PRUEBA_ACTIVAS = false`: vuelven las miniaturas de siempre
// (`/images/multi-vistas/otros/maniqui_*.jpeg`).
// Para borrarlo del todo: eliminar este archivo, la carpeta
// `public/images/multi-vistas/prueba/` y las dos líneas marcadas con "PRUEBA" en
// `VistaPickerFullscreen.tsx`.
//
// ── CÓMO PROMOVERLO ───────────────────────────────────────────────────────────────────
// Si las nuevas quedan: reemplazar los archivos de `otros/maniqui_*.jpeg` por estos y
// borrar el interruptor. Así el ejemplo vuelve a estar donde lo busca cualquiera —al lado
// del resto de las miniaturas— en vez de en un override.
// ──────────────────────────────────────────────────────────────────────────────────────

/** Prendido = el picker usa las miniaturas de prueba.
 *
 *  APAGADO el 2026-08-27, a pedido: vuelven las miniaturas de siempre
 *  (`/images/multi-vistas/otros/maniqui_*.jpeg`). */
export const VISTAS_PRUEBA_ACTIVAS = false;

/**
 * Miniatura de prueba por id de vista. Lo que no está acá no se toca.
 *
 * Las tres son de maniquí invisible; las de "Plano" siguen con las de producción.
 */
const MINIATURAS_PRUEBA: Record<string, string> = {
  maniqui_frontal: '/images/multi-vistas/prueba/maniqui_frente.png',
  maniqui_trasero: '/images/multi-vistas/prueba/maniqui_trasero.png',
  maniqui_angulo: '/images/multi-vistas/prueba/maniqui_angulo.png',
};

/** La miniatura de prueba de esa vista, o null si esa vista no tiene override. */
export const miniaturaDeVistaPrueba = (vistaId: string): string | null =>
  (VISTAS_PRUEBA_ACTIVAS ? MINIATURAS_PRUEBA[vistaId] : undefined) ?? null;
